export const DEFAULT_ACCOUNTANT_SEAWEED_ACCESS_TABS = ['releasing', 'expenses'];

export const SEAWEED_ADMIN_TAB_OPTIONS = [
  { value: 'overview', label: 'Dashboard', path: '/admin/dashboard' },
  { value: 'daily-entries', label: 'Daily Entries', path: '/admin/daily-entries' },
  { value: 'sales-order', label: 'Sales Order', path: '/admin/sales-order' },
  { value: 'purchase-order', label: 'Purchase Order', path: '/admin/purchase-order' },
  { value: 'dumping', label: 'Dumping', path: '/admin/dumping' },
  { value: 'inventory', label: 'Inventory', path: '/admin/inventory' },
  { value: 'releasing', label: 'Releasing', path: '/admin/releasing' },
  { value: 'sales-analytics', label: 'Release Analytics', path: '/admin/sales-analytics' },
  { value: 'supplier', label: 'Supplier', path: '/admin/supplier' },
  { value: 'cash-advance', label: 'Cash Advance', path: '/admin/cash-advance' },
  { value: 'supplier-savings', label: 'Supplier Savings', path: '/admin/supplier-savings' },
  { value: 'manage-suppliers', label: 'Manage Suppliers', path: '/admin/supplier' },
  { value: 'lansa', label: 'Master Data', path: '/admin/lansa' },
  { value: 'lansa-name', label: 'Lansa Name', path: '/admin/lansa?tab=lansa-name' },
  { value: 'seaweed-type', label: 'Seaweed Types', path: '/admin/lansa?tab=seaweed-type' },
  { value: 'warehouse-location', label: 'Warehouse Location', path: '/admin/lansa?tab=warehouse-location' },
  { value: 'tare-amount-fee', label: 'Tare Amount Fee', path: '/admin/lansa?tab=tare-amount-fee' },
  { value: 'savings-per-kilo', label: 'Savings per Kilo', path: '/admin/lansa?tab=savings-per-kilo' },
  { value: 'expenses', label: 'Expenses', path: '/admin/expenses' },
  { value: 'customer', label: 'Customer', path: '/admin/customer' },
];

export const SEAWEED_ACCOUNTANT_TAB_PATHS = SEAWEED_ADMIN_TAB_OPTIONS.map((item) => [
  item.value,
  item.path,
]);
